import React, { Component } from "react";
import {
  toFixed,
  GET,
  loading,
  Status,
  Pagination,
  Navbar,
  copyText,
  maskAccount,
} from "../../components/CustomComponent.js";
// สีของสถานะ KYC ตามค่าที่ Primerlo คืน (เหมือนหน้า admin customers)
const KYC_COLORS = {
  none: "secondary",
  pending: "warning",
  review: "warning",
  rejected: "danger",
  expired: "danger",
  bank_required: "orange",
  approved: "success",
};
export default class Customers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",
      filter_currency: "THB",

      data: [],
      loaded: false,
      count: 0,
      page: 1,
      page_size: 10,
    };
  }

  // สถานะ KYC กับ Primerlo (customers_gatewaies.kyc_status) ลูกค้าที่ไม่เคยเข้า Primerlo แสดง "-"
  renderKyc = (item) => {
    const kyc = item.gateway_register?.find((g) => g.gateway_name === "primerlo")?.kyc_status;
    return kyc ? Status(kyc, KYC_COLORS[kyc] || "secondary") : <span className="pu-none">-</span>;
  };
  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const { filter_search, filter_currency, page_size } = this.state;
    loading(true);
    const result = await GET("v1/admin/customers", {
      page_size: page_size,
      page: page,
      data_search: filter_search,
      currency: filter_currency,
    });
    loading(false);

    // ยิงไม่ผ่านต้องคงข้อมูลเดิมไว้ ไม่ใช่ล้างตารางเป็น No data โดยไม่บอกสาเหตุ
    if (result?.status !== true) {
      this.setState({ loaded: true });
      return;
    }

    this.setState({
      loaded: true,
      page: page,
      data: result.data || [],
      count: result.pagination?.count || 0,
    });
  };
  render() {
    const { filter_search, filter_currency, data, loaded, count, page, page_size } =
      this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
<div>
              <div className="ar-eyebrow mb-1">Agent</div>
              <h2 className="ar-title mb-1">Customers Management</h2>
              <div className="ar-subtitle">Manage agent customers</div>
            </div>
            </div>
<div className="ar-toolbar ar-filter mt-3">
  <div className="ar-filter-head">
    <span className="ar-toolbar-label"><span className="icon me-2">{"\uf0b0"}</span>Filter</span>
    <span className="ar-toolbar-hint">Press Enter in the search box or click Search to apply</span>
  </div>
  <div className="ar-filter-row">
    <div className="ar-filter-field ar-filter-field-search">
      <span className="ar-filter-label">Search</span>
                <input
                  type="text"
                  className="form-control pr-input"
                  placeholder="Search..."
                  onChange={(e) => {
                    this.setState({ filter_search: e.target.value });
                  }}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      this.Get(1);
                    }
                  }}
                  value={filter_search}
                />
    </div>
    <div className="ar-toolbar-actions">
                <button
                  className="ar-btn-gold"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  <span className="icon me-2">{"\uf002"}</span>Search
                </button>
                <button
                  className="ar-btn-ghost"
                  onClick={() =>
                    this.setState(
                      { filter_search: "", filter_currency: "THB" },
                      () => this.Get(1)
                    )
                  }
                >
                  Reset
                </button>
    </div>
  </div>
  <div className="ar-filter-foot">
                  {global.currency?.map((item) => (
                    <button
                      className={`ar-pill ${
                        item.currency_code === filter_currency ? "active" : ""
                      }`}
                      onClick={() => {
                        this.setState({ filter_currency: item.currency_code });
                        setTimeout(() => {
                          this.Get(1);
                        }, 100);
                      }}
                    >
                      {item.image}
                      <span className="ms-1">{item.currency_code}</span>
                    </button>
                  ))}
  </div>
</div>
            </div>
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{"\uf1ad"}</span>
                  Customers
                  <span className="pu-currency-tag">{filter_currency}</span>
                </div>
                <div className="ar-table-caption">Agent customers</div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    <td className="text-nowrap">Broker</td>
                    <td className="text-nowrap">Customer UID</td>
                    <td className="text-nowrap">Customer</td>
                    <td className="text-nowrap">Bank</td>
                    <td className="text-nowrap">Account Number</td>
                    <td className="text-nowrap">Total Deposits</td>
                    <td className="text-nowrap">Total Withdrawals</td>
                    <td className="text-center text-nowrap wpx-100">KYC</td>
                    <td className="text-center text-nowrap wpx-100">Status</td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={`array-${index}`}>
                      <td data-label="Broker" className="text-nowrap">
                        {item.broker?.name_en || item.broker?.name_th || "-"}
                      </td>
                      <td data-label="Customer UID" className="text-nowrap">
                        <div className="d-flex justify-content-between align-items-center">
                          {item.uid ? item.uid.slice(0, 12) + "..." : "-"}
                          <span
                            className="icon pointer ms-2"
                            title="Copy"
                            onClick={() => {
                              copyText(item.uid || "");
                            }}
                          >
                            {"\uf0c5"}
                          </span>
                        </div>
                      </td>
                      <td data-label="Customer" className="text-nowrap">
                        {item.name_en || item.name_th || "-"}
                      </td>
                      <td data-label="Bank" className="text-nowrap">
                        {item.bank_code &&
                        global.bank.find((e) => e.value === item.bank_code) ? (
                          <div>
                            <img
                              alt="bank"
                              src={require(`../../assets/images/bank/${
                                global.bank.find(
                                  (b) => b.value === item.bank_code
                                )?.icon || "bank.png"
                              }`)}
                              width={18}
                              height={18}
                              style={{ marginRight: 6 }}
                              className="me-2"
                            />
                            {item.bank_code}
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td data-label="Account Number" className="text-nowrap">
                        {maskAccount(item.bank_account_number) || "-"}
                      </td>
                      <td data-label="Total Deposits" className="text-nowrap">
                        <div style={{ height: 14 }}>
                          {toFixed(item.total_deposits, 2) || "0.00"}
                        </div>
                        <small
                          className={
                            item.order_deposits
                              ? "text-primary"
                              : "text-secondary"
                          }
                        >
                          {item.order_deposits || 0} orders
                        </small>
                      </td>
                      <td
                        data-label="Total Withdrawals"
                        className="text-nowrap"
                      >
                        <div style={{ height: 14 }}>
                          {toFixed(item.total_withdrawals, 2) || "0.00"}
                        </div>
                        <small
                          className={
                            item.order_withdrawals
                              ? "text-primary"
                              : "text-secondary"
                          }
                        >
                          {item.order_withdrawals || 0} orders
                        </small>
                      </td>
                      <td data-label="KYC" className="text-nowrap text-center">
                        <div className="d-flex align-items-center justify-content-center">{this.renderKyc(item)}</div>
                      </td>
                      <td
                        data-label="Status"
                        className="text-nowrap text-center"
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          {item.is_active
                            ? Status("active", "success")
                            : Status("inactive", "danger")}
                        </div>
                      </td>
                    </tr>
                  ))}
                  {loaded && data?.length === 0 && (
                    <tr>
                      <td
                        colSpan={9}
                        className="text-center text-secondary py-4"
                      >
                        No data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / page_size) || 1}
              page={page}
              showFirstButton
              showLastButton
              onChange={(_, value) => this.Get(value)}
            />
          </div>
        </div>
      </div>
    );
  }
}
